import { DatePicker } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { COLOR_SCHEME } from '@namespace/themes';
import { IS_WIDGET } from '@namespace/widget';

import styles from '../../index.module.css';

export const DayPickerFilter = ({
  date,
  selectDay,
  intentType = COLOR_SCHEME.SECONDARY
}) => {
  const { f } = useI18n();
  const DATE_FORMATS_TYPES = f.getFormats();

  return (
    <DatePicker
      date={date}
      onChange={selectDay}
      disabledSuccess={true}
      minDate={f.getDateTime().toISODate()}
      maxDate={f.getDateTime().plus({ days: 7 }).toISODate()}
      size="xs"
      format={`${DATE_FORMATS_TYPES.EVENTS_LINE_DATE} cccc`}
      className={styles.datePickerContainer}
      variant={IS_WIDGET ? 'inline' : 'dialog'}
      intentType={intentType}
    />
  );
};
